import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BetHistoryComponent } from './bet-history/bet-history';
import { TranslateModule } from '@ngx-translate/core';
import { BetHistoryDetailsComponent } from './bet-history-details/bet-history-details';
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
  declarations: [
    BetHistoryComponent,
    BetHistoryDetailsComponent
  ],
  imports: [   
    TranslateModule,
    MyDatePickerModule,
    IonicPageModule.forChild(BetHistoryModule),
  ],
  exports: [
    BetHistoryComponent,
    BetHistoryDetailsComponent
  ]
})
export class BetHistoryModule {}



// WEBPACK FOOTER //
// ./src/app/shared/bet-history/bet-history.module.ts